/**
 * Transforms a provided value to a boolean property
 * 'false' => false
 * '' => true
 * null => false
 *
 */
export function toBooleanProperty(value: any): boolean {
  return value != null && `${value}` !== 'false';
}
